// extracted by mini-css-extract-plugin
module.exports = {"sectionControlContainer":"style_sectionControlContainer__1zpwF"};